import { combineReducers, idleState, failedState, loadingState } from "@grandvisionhq/state";
import { cccReducer } from "./CCC/CCC/reducer.js";
import { prescriptionsReducer } from "./Prescriptions/state/Prescriptions/state/reducer.js";
import { profileReducer } from "./Profile/Profile/reducer.js";
import { unlinkOrderFailed, unlinkOrderSuccess, unlinkOrder } from "./Unlink/Unlink/actions.js";
const initialState = {
  unlinkOrderCall: idleState()
};
const unlinkOrderReducer = (state = initialState.unlinkOrderCall, action) => {
  switch (action.type) {
    case unlinkOrder.type:
      return loadingState();
    case unlinkOrderSuccess.type:
      return idleState();
    case unlinkOrderFailed.type:
      return failedState(action.error);
    default:
      return state;
  }
};
const reducer = combineReducers({
  profile: profileReducer,
  ccc: cccReducer,
  prescriptions: prescriptionsReducer,
  unlinkOrderCall: unlinkOrderReducer
});
export {
  reducer as default,
  initialState
};
//# sourceMappingURL=reducer.js.map
